var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 14,
    viewBox: "0 0 54 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5084 6.66705C40.5084 10.3109 43.4623 13.2648 47.1061 13.2648C50.7499 13.2648 53.7038 10.3109 53.7038 6.66705C53.7038 3.02323 50.7499 0.0693361 47.1061 0.0693359C43.4623 0.0693358 40.5084 3.02323 40.5084 6.66705ZM20.7153 6.66705C20.7153 10.3109 23.6692 13.2648 27.313 13.2648C30.9568 13.2648 33.9107 10.3109 33.9107 6.66705C33.9107 3.02323 30.9568 0.0693371 27.313 0.069337C23.6692 0.0693368 20.7153 3.02323 20.7153 6.66705ZM7.51983 13.2648C3.87602 13.2648 0.922119 10.3109 0.922119 6.66705C0.922119 3.02323 3.87602 0.069336 7.51983 0.0693361C11.1636 0.0693363 14.1175 3.02323 14.1175 6.66705C14.1175 10.3109 11.1636 13.2648 7.51983 13.2648Z",
    fill: "#5926f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterA);
export default __webpack_public_path__ + "static/media/Filter_a.b05830bb7778895c9795f448b7b9721f.svg";
export { ForwardRef as ReactComponent };